import React from "react";
import ReactiveComponent from "@usereactify/search-internals/lib/components/basic/ReactiveComponent";

import {
  useReactifySearchContext,
  useSortBy,
  useFlags,
  useSearch,
} from "../../hooks";
import { getPropsSensorSort } from "../../utility/props";

export const SensorSort: React.FC = () => {
  const flagsHook = useFlags();
  const reactifySearchContext = useReactifySearchContext();
  const { sortOption } = useSortBy();
  const { searchTerm } = useSearch();

  const reactiveProps = getPropsSensorSort({
    config: reactifySearchContext.config,
    provider: reactifySearchContext.options,
    sortOption: sortOption?.handle,
    searchTerm: searchTerm,
  });

  if (!flagsHook.flags["reactify-search:flag_sensor_sort"]) {
    return null;
  }

  return (
    <ReactiveComponent
      {...reactiveProps}
    />
  );
};
